var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['wrap',_vm.$route.meta.hasHeaderFix?'has-header':'']},[(_vm.$route.meta.hasHeader)?_c('page-header'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }